import axios from 'axios';
import { toast } from 'react-toastify';
import { store } from '../app/store';
import { logout } from '../features/auth/authSlice';

// Add response interceptor to handle 401 errors globally
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Clear invalid token from storage
            localStorage.removeItem('token');
            sessionStorage.removeItem('token');
            localStorage.removeItem('user');
            sessionStorage.removeItem('user');

            // Dispatch logout action to clear Redux state
            store.dispatch(logout());

            // Notify user (only once by checking if already shown)
            if (!window.sessionExpiredToastShown) {
                toast.error("Your session has expired. Please log in again.");
                window.sessionExpiredToastShown = true;

                // Reset flag after navigation
                setTimeout(() => {
                    window.sessionExpiredToastShown = false;
                }, 1000);
            }

            // Redirect to login
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axios;